import React, {
  FC, useEffect, useState,
} from 'react';
import { IoCloseCircleOutline } from "react-icons/io5";
import { Cab } from '../../../../lib/types';
import { getFoodifoxDataLazy } from '../../../../lib/axios/FoodifoxDataAPI';
import Button from '../../../../components/Button';
import Header from '../../Common/Header';
import Input from '../../../../components/Input';
import ColumnCenter from '../../../../components/Layout/ColumnCenter';
import { isMobile, lang } from '../../../../lib/utils/utils';
import PingFangSemiBoldText from '../../../../components/Text/PingFangSemiBoldText';
import RowCenter from '../../../../components/Layout/RowCenter';
import Loading from '../../../../components/Loading';
import { FoodifoxLogo } from '../../../../assets/base64Images/logo/logo';
import { SearchIcon } from '../../../../assets/svg-image/common';
import Row from '../../../../components/Layout/Row';
import InterMediumText from '../../../../components/Text/InterMediumText';
import InterRegularText from '../../../../components/Text/InterRegularText';
import Column from '../../../../components/Layout/Column';
import InterMediumItalicText from '../../../../components/Text/InterMediumItalicText';
import TermsConditionsModal from '../../Common/TermsConditionsModal';

const SelectLocker: FC<Props> = ({
  targetPage,
  setTargetPage,
  isEnglish,
  setIsEnglish,
  setCabData,
  setIsToSelectLockerPage,
}) => {
  const [getCabList, { loading }] = getFoodifoxDataLazy<Cab[]>('/foxH5Home/getCabList');
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [selectCab, setSelectCab] = useState<Cab>();
  const [inputCabName, setInputCabName] = useState<string>();
  const [inputValue, setInputValue] = useState<string>('');
  const [cabList, setCabList] = useState<Cab[]>([]);
  const [filterCabList, setFilterCabList] = useState<Cab[]>([]);
  const [showTermsModal, setShowTermsModal] = useState<boolean>(false);

  useEffect(() => {
    getCabList({
      onCompleted: (data) => {
        setCabList([...new Map(data.map(item => [item.cabName, item])).values()]);
      },
    });
  }, []);

  useEffect(() => {
    if (inputValue.length > 2) {
      setFilterCabList(cabList.filter((cab) => cab.cabName.toLowerCase().includes(inputValue.toLowerCase())));
    }
    else {
      setFilterCabList([]);
    }
  }, [inputValue, cabList]);

  useEffect(() => {
    setShowLoading(loading);

    return () => {
      setShowLoading(false);
    };
  }, [loading]);

  return (
    <>
      {
        showTermsModal && (
          <TermsConditionsModal
            callback={() => {
              setShowTermsModal(false);
            }}
            showAgreeBtn={false}
            showExitBtn={false}
            isEnglish={isEnglish}
          />
        )
      }
      {
        (showLoading) && (
          <Loading />
        )
      }
      <Column style={{ alignItems: isMobile() ? undefined : 'center' }}>
        <div style={{ width: isMobile() ? undefined : 400 }}>
          {/* 头部 */}
          <Header
            isEnglish={isEnglish}
            setIsEnglish={setIsEnglish}
            style={{ marginTop: '20px' }}
            setTargetPage={setTargetPage}
            supportIsOnlyCall={true}
          />

          <RowCenter style={{ marginTop: filterCabList.length > 0 ? 30 : '30%' }}>
            {/* Logo */}
            <img src={FoodifoxLogo} style={{ width: 171 }} />
          </RowCenter>

          <ColumnCenter style={{ width: 270, minHeight: 55, backgroundColor: 'rgba(228, 228, 228, 0.5)', borderRadius: 5, marginTop: 34, marginLeft: 'auto', marginRight: 'auto' }}>
            <Row style={{ paddingLeft: 20, paddingRight: 30 }}>
              <Input
                placeholderColor={'rgba(0, 0, 0, 0.5)'}
                backgroundColor={'transparent'}
                placeholderOpacity={0.5}
                fontSize={18}
                fontFamily={'Inter-Medium'}
                placeholder={'Search your building address'}
                placeFontFamily={'Inter-Medium'}
                placeFontSize={18}
                style={{ maxHeight: 50, minHeight: 50, borderRadius: 5, width: 215 }}
                onChange={(e) => {
                  setInputValue(e.target.value);
                  setInputCabName('');
                }}
                value={inputCabName || inputValue}
              />
              {
                (inputCabName || inputValue) ? (
                  <IoCloseCircleOutline
                    style={{ fontSize: 18, cursor: 'pointer' }}
                    onClick={() => {
                      setInputCabName('');
                      setInputValue('');
                      setSelectCab(undefined);
                    }}
                  />
                ) : (
                  <img src={SearchIcon} style={{ width: 15, height: 15 }} />
                )
              }
            </Row>

            <Column style={{ width: '100%', paddingBottom: filterCabList.length > 0 ? 10 : 0 }}>
              {
                filterCabList.map((cab, index) => {
                  return (
                    <Column key={index}>
                      {
                        index > 0 && (
                          <div style={{ backgroundColor: '#000000', opacity: 0.5, width: '100%', height: 1, marginTop: 10, marginBottom: 10 }} />
                        )
                      }
                      <Row
                        key={cab.cabId}
                        style={{ width: 240, alignItems: 'center', paddingLeft: 15, paddingRight: 15 }}
                        onClick={() => {
                          // 设置选中的cabId
                          setSelectCab(cab);
                          // 设置输入框的值为选中的cabName
                          setInputCabName(cab.cabName);
                          // 清空过滤列表
                          setFilterCabList([]);
                        }}
                      >
                        <InterRegularText opacity={0.5} fontSize={18} lineHeight={20}>
                          {cab.cabName}
                        </InterRegularText>
                      </Row>
                    </Column>
                  );
                })
              }
            </Column>
          </ColumnCenter>

          <RowCenter style={{ marginTop: 40 }}>
            <Button
              minWidth={200}
              height={60}
              backgroundColor={selectCab ? '#00D2B9' : '#E4E4E4'}
              borderRadius={5}
              onClick={() => {
                if (selectCab) {
                  setCabData(selectCab);
                  setIsToSelectLockerPage(false);
                  setTargetPage(targetPage);
                }
              }}
            >
              {
                lang(
                  <InterMediumText color={'#FFFFFF'} fontSize={18}>
                    Select
                  </InterMediumText>,
                  <PingFangSemiBoldText color={'#FFFFFF'} fontSize={18}>
                    选择
                  </PingFangSemiBoldText>
                )
              }
            </Button>
          </RowCenter>

          <RowCenter style={{ position: 'fixed', bottom: 0, paddingBottom: 10, paddingTop: 5, width: '100%', backgroundColor: '#FFFFFF' }}>
            <Button onClick={() => setShowTermsModal(true)}>
              <InterMediumItalicText fontSize={12} textDecorationLine={'underline'}>
                Terms of use and Privacy Policy
              </InterMediumItalicText>
            </Button>
          </RowCenter>
        </div>
      </Column>
    </>
  );
};

export interface Props {
  targetPage?: string;
  setTargetPage: (targetPage?: string) => void;
  isEnglish: boolean;
  setIsEnglish: (isEnglish: boolean) => void;
  setCabData: (cab: Cab) => void;
  setIsToSelectLockerPage: (isToLockerPage: boolean) => void;
}

export default SelectLocker;
